import { RESTClient } from '@api/client';
import { RequestSiteConfigurationType } from '@dynamika-shared/types/site';

export const createSite = (ctId: string, body: RequestSiteConfigurationType) => {
    return RESTClient.post(`clinical-trials/${ctId}/sites`, body);
};

export const updateSite = (ctId: string, siteId: string, body: RequestSiteConfigurationType) => {
    return RESTClient.put(`clinical-trials/${ctId}/sites/${siteId}`, body);
};

export const deleteSite = (ctId: string, siteId: string) => {
    return RESTClient.delete(`clinical-trials/${ctId}/sites/${siteId}`);
};
